import { apiService, getAuthValues, setAuthHeader } from "./api";

const fetchCompanyInfo = async () => {
  const { token, companyId } = getAuthValues();
  setAuthHeader(token!);
  const company: any = await apiService.get(
    `/company/{companyId}/load-chat/chatID/messages`
  );
  return company;
};

const fetchCountryCode = async () => {
  try {
    const response = await apiService.get(`/public?type=getCountryCodeAPIUrl`);
    if (response.status === 200) {
      const data = response.data;
      const url = data.url;
      const countryRes = await fetch(url);
      const countryResData = await countryRes.json();
      return countryResData.countryCode;
    } else {
      return null;
    }
  } catch (error) {
    console.error("Error fetching country code", error);
  }
};

export { fetchCompanyInfo, fetchCountryCode };
